export default {
    initializing: true,
    initializingFailed: false,
    bootProgress: 0.0,
    loadingItems: [],
    everythingLoaded: false,
    navLoaded: false,
    experienceMarkersLoaded: false,
    modal: false,
    navOpen: true,
    filter: null,
    title: null,
    navOption: null,
    prevNavOption: null,
    experienceMarker: null,
    mapFilter: null,
    mapBounds: null,
    renderMapBounds: true,
    geoData: null,
    experience: null,
    footerOpen: true,
    auxResourceUrl: null,
    auxResourceName: null,
};